import React from "react";

function Modal({ children, styles, show, transition, containerClasses, onClose }) {
    const handleBackdropClick = (e) => {
        if (onClose) {
            onClose();
        }
    };

    return (
        <div className="">
            {show ? (
                <>
                    <div
                        onClick={handleBackdropClick}
                        className={`${transition || 'animateup'} w-full justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-[99] outline-none focus:outline-none`}
                    >
                        <div 
                            className={`fixed lg:relative lg:bottom-none max-w-3xl w-full lg:my-6 bottom-0 bg-white ${styles} ${containerClasses}`}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/*content*/}
                            <div style={{ height : '100%' }} className="border-0 rounded-lg shadow-lg relative flex flex-col w-full outline-none focus:outline-none">
                                {children}
                            </div>
                        </div>
                    </div>

                    {/* BACKDROP */}
                    <div onClick={handleBackdropClick} className="opacity-70 fixed inset-0 z-[9] bg-black"></div>
                </>
            ) : null}
        </div>
    )
}

export default Modal